import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Konza";
import campaign from "../assets/wetu/Optiven @ 24.png";

const TulivuGardens = () => {
  const projectId = "PRJ00060";
  const title = "Tulivu Gardens Phase 3";

  // Replicating KonzaComponent logic
  const mapConfig = {
    minZoom: 12,
    zoom: 13,
    bounds: [
      [40.74, -74.16],
      [40.65, -74.03],
    ],
    imageOverlays: [
        {
          imageUrl: campaign,
          imageBounds: [
            [40.71, -74.05],
            [40.69, -74.02],
          ],
        },
      ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/tulivu-gardens-phase-3-konza/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSfKtepovIXZFgB3H2RcHa2VuTXbPOhk1KUa4stx5XhdSMbtbg/viewform"
    />
  );
};

export default TulivuGardens;
